import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck, ExternalLink } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useSite } from "../../context/SiteContext";
import WorkspaceSwitch from "../WorkspaceSwitch";

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const { settings } = useSite();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/admin/login", { replace: true }); };
  return (
    <div className="min-h-screen flex flex-col bg-[#F3F5F4] text-[#192621]" data-testid="admin-layout">
      <header className="sticky top-0 z-40 bg-[#07221A] text-white shadow-md" data-testid="admin-header">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-14 flex items-center justify-between gap-3">
          <Link to="/admin/dashboard" className="flex items-center gap-2.5 min-w-0" data-testid="admin-brand">
            <img src={settings?.logo_url || "/logo.png"} alt="" className="w-8 h-8 rounded-lg shrink-0" />
            <div className="min-w-0 leading-tight">
              <p className="font-serif-luxury text-base font-bold truncate">6SigmaCare</p>
              <p className="text-[10px] uppercase tracking-wider text-amber-300 flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> Administration Console</p>
            </div>
          </Link>
          <div className="flex items-center gap-2 sm:gap-4 text-xs">
            {user && <span className="hidden sm:block text-emerald-200 truncate max-w-[220px]" data-testid="admin-header-user">{user.name} · <span className="uppercase">{user.role?.replace("_", " ")}</span></span>}
            <a href="/" target="_blank" rel="noreferrer" className="hidden sm:inline-flex items-center gap-1 text-emerald-200 hover:text-white" data-testid="admin-view-site">View site <ExternalLink className="w-3 h-3" /></a>
            <div className="relative hidden sm:block"><WorkspaceSwitch className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/10 hover:bg-white/20 font-semibold transition-colors" /></div>
            <button onClick={doLogout} data-testid="admin-logout-btn" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/10 hover:bg-rose-600 font-semibold transition-colors"><LogOut className="w-3.5 h-3.5" /> Sign out</button>
          </div>
        </div>
      </header>
      <main className="flex-1 min-w-0">{children}</main>
      <footer className="py-4 text-center text-[11px] text-gray-500" data-testid="admin-footer">Authorized personnel only · All actions are audited</footer>
    </div>
  );
}
